var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.731 13.6509C34.9503 14.814 33.9624 15.8497 32.8152 16.6782C32.8312 16.9172 32.8312 17.1722 32.8312 17.4271C32.8312 25.1547 26.9518 34.0614 16.2128 34.0614C12.9146 34.0614 9.83949 33.0895 7.24237 31.4324C7.70443 31.4802 8.1665 31.5121 8.6445 31.5121C11.385 31.5121 13.9025 30.572 15.8941 29.0106C14.6758 28.9854 13.4957 28.5803 12.5188 27.8519C11.5419 27.1234 10.8168 26.1081 10.445 24.9476C10.7955 25.0113 11.162 25.0591 11.5443 25.0591C12.0701 25.0591 12.5959 24.9795 13.0739 24.852C11.7524 24.5807 10.5649 23.862 9.71158 22.8172C8.85825 21.7723 8.39134 20.4651 8.38956 19.116V19.0523C9.18623 19.4825 10.0785 19.7534 11.0345 19.7852C10.2343 19.2485 9.57876 18.5228 9.12577 17.6725C8.67279 16.8221 8.43635 15.8732 8.43736 14.9096C8.43736 13.8421 8.72416 12.8383 9.23403 11.9779C12.1179 15.5151 16.4199 17.8414 21.2796 18.0804C21.184 17.6502 21.1202 17.204 21.1202 16.742C21.1245 15.1939 21.7424 13.7106 22.8386 12.6175C23.9347 11.5243 25.4196 10.9104 26.9677 10.9104C28.6567 10.9104 30.1703 11.6115 31.2379 12.7587C32.5603 12.4878 33.819 12.0098 34.9503 11.3406C34.5042 12.6949 33.58 13.8421 32.3691 14.5591C33.53 14.4322 34.6642 14.1258 35.731 13.6509Z",
    fill: "#F36F2E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.0898,
    cy: 21.8606,
    r: 20.3366,
    stroke: "#F36F2E",
    strokeWidth: 1.50642
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b2ff1d1ddcb12e6d1f9fffdff5b0932d.svg";
export { ForwardRef as ReactComponent };